import axios from 'axios';
import axiosClient from './axiosClient';

/**
 * Authenticates a user with their MSISDN and handles token management
 * @param {string} msisdn - The user's MSISDN number
 * @returns {Promise<Object>} - The authentication response
 */
export const authenticateUser = async (msisdn, refferer) => {
  try {
    // Make a direct axios call to avoid the interceptor for this specific endpoint
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/v1/jt/gen`, { msisdn, refferer });

    // Get the access token from headers
    const accessToken = response.headers['access_token'];

    if (accessToken) {
      // Save the token and MSISDN
      sessionStorage.setItem('access_token', accessToken);
      sessionStorage.setItem('msisdn', msisdn);

      // Update axios client default headers
      axiosClient.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

      return {
        success: true,
        data: response.data
      };
    } else {
      throw new Error('No access token received');
    }
  } catch (error) {
    // console.error('Authentication failed:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Checks if the user is authenticated
 * @returns {boolean} - Whether the user is authenticated
 */
export const isAuthenticated = () => {
  if (sessionStorage.getItem('gamesNowRef') === 'true') {
    // console.log("GamesNowRef found in sessionStorage, returning true for authentication check.");
    return true;
  }
  return !!(sessionStorage.getItem('access_token') && sessionStorage.getItem('msisdn'));
};

/**
 * Logs out the user by clearing stored credentials
 */
export const logout = () => {
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('msisdn');
  delete axiosClient.defaults.headers.common['Authorization'];
};

/**
 * Get active day data
 * @returns {Promise} Response from the API
 */
export const getActiveDay = async () => {
  try {
    const response = await axiosClient.get('/v1/active-day');
    return response.data;
  } catch (error) {
    // console.error('Error fetching active day:', error);
    throw error;
  }
};

/**
 * Update active day
 * @returns {Promise} Response from the API
 */
export const updateActiveDay = async () => {
  try {
    const response = await axiosClient.post('/v1/update-active-day');
    return response.data;
  } catch (error) {
    // console.error('Error updating active day:', error);
    throw error;
  }
};

export const claimDailyReward = async (day) => {
  try {
    const response = await axiosClient.post('/v1/claim-daily-reward', { day });
    return response.data;
  } catch (error) {
    // console.error('Error claiming daily reward:', error);
    throw error;
  }
};

export const getActiveDayData = async () => {
  try {
    const response = await axiosClient.get('/v1/active-streak');
    return response.data;
  } catch (error) {
    // console.log("Failed active streak " + error);
    throw error;
  }
}

export const updateActiveDayData = async () => {
  try {
    const response = await axiosClient.post('/v1/update-daily-streak');
    return response.data;
  } catch (error) {
    // console.log("Failed active streak " + error);
    throw error;
  }
}